import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';
import { getUpcomingSearch } from '@/utils/upcomingSearch';

export const DEFAULT_MP_PAGE_SIZE = 50;

export const DONATION_ITEM_LOOKUP_PARAMS = { isActive: true, page: 1, pageSize: 200 } as const;

export const DONATION_UPCOMING_SEARCH = getUpcomingSearch('Institute, Teacher, ZM');

export const DONATION_DECISION = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  RECOMMENDED: 3,
} as const;

export const DECISION_OPTIONS = [
  { id: DONATION_DECISION.PENDING, name: 'Pending' },
  { id: DONATION_DECISION.RECOMMENDED, name: 'Recommended' },
  { id: DONATION_DECISION.APPROVED, name: 'Approved' },
  { id: DONATION_DECISION.REJECTED, name: 'Rejected' },
] as const;

export const DECISION_LABEL: Record<number, string> = {
  [DONATION_DECISION.PENDING]: 'Pending',
  [DONATION_DECISION.RECOMMENDED]: 'Recommended',
  [DONATION_DECISION.APPROVED]: 'Approved',
  [DONATION_DECISION.REJECTED]: 'Rejected',
};

export const DECISION_TONE: Partial<Record<number, StatusColorTone>> = {
  [DONATION_DECISION.PENDING]: APPROVAL_STATUS_TONE.pending,
  [DONATION_DECISION.RECOMMENDED]: APPROVAL_STATUS_TONE.recommended,
  [DONATION_DECISION.APPROVED]: APPROVAL_STATUS_TONE.approved,
  [DONATION_DECISION.REJECTED]: APPROVAL_STATUS_TONE.rejected,
};
